import React from 'react';
import { renderToString } from 'react-dom/server';

import { AddressCardIcon } from '../../../icon/regular';
import {
  BaseSaveInstructionData,
  InstructionActionTooltip,
  InstructionCSSClasses,
  InstructionEvent,
} from '../types';
import InlineInstruction from '../base-instruction/InlineInstruction';
import { addInstructionEvent, emitInstructionEvent } from '../utils';

class TitleInstruction extends InlineInstruction {
  protected static title = 'Title';

  get icon() {
    return renderToString(<AddressCardIcon style={{ height: 20 }} />);
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.TITLE_INSTRUCTION_WRAPPER,
      content: InstructionCSSClasses.TITLE_INSTRUCTION_CONTENT,
      action: InstructionCSSClasses.TITLE_INSTRUCTION_ACTION,
    };
  }

  openModal(instructionId: string): void {
    this.initEvents();
    emitInstructionEvent(this.api.events, InstructionEvent.OPEN_TITLE_INSTRUCTION_MODAL, {instructionId, isInline: true});
  }

  getTooltip(tooltip: string): string {
    return `${InstructionActionTooltip.title}: ${tooltip}`;
  }

  initEvents() {
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_TITLE_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SET_TITLE_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  removeEvents() {
    this.api.events.off(
      InstructionEvent.SAVE_TITLE_INSTRUCTION,
      this.saveInstruction.bind(this),
    );
    this.api.events.off(
      InstructionEvent.SET_TITLE_INSTRUCTION_SELECTION,
      this.cancel.bind(this),
    );
  }

  saveInstruction(data: BaseSaveInstructionData) {
    if (!this.isActive) {
      this.wrap(data);
    }
    this.removeEvents();
  }

  cancel() {
    this.setSelection();
    this.removeEvents();
  }
}

export default TitleInstruction;
